import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getExperiment } from '../services/experiments.service';

/** One experiment's record — shared by the wizard (draft resume) and the detail page. */
export function useExperiment(experimentId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.catalogService.experimentDetail(experimentId ?? ''),
    queryFn: () => getExperiment(experimentId ?? ''),
    enabled: !!experimentId,
  });
}
